module.exports = __webpack_public_path__ + "fonts/smartcommerce-iconfont.abe411f2.eot";